var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.viewer)?_c('viewer',[_c('img',{attrs:{"src":_vm.resizeImg,"data-source":_vm.src,"alt":_vm.alt,"onerror":_vm.onerror}})]):_c('img',{attrs:{"src":_vm.resizeImg,"alt":_vm.alt,"onerror":_vm.onerror}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0895c704","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oss-img/index.vue
// module id = null
// module chunks = 